type RequestConfig = {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  params?: unknown;
  data?: unknown;
};

const PASS: unique symbol = Symbol('interceptor.pass');

type Interceptor = (config: RequestConfig) => unknown;

const interceptors = new Set<Interceptor>();

const addInterceptor = (fn: Interceptor): (() => void) => {
  interceptors.add(fn);
  return () => {
    interceptors.delete(fn);
  };
};

const removeInterceptor = (fn: Interceptor) => {
  interceptors.delete(fn);
};

const runInterceptors = async (config: RequestConfig): Promise<unknown> => {
  for (const interceptor of interceptors) {
    const result = await interceptor(config);
    if (result !== PASS) return result;
  }
  return PASS;
};

export { addInterceptor, PASS, removeInterceptor, runInterceptors };
export type { Interceptor, RequestConfig };
